import Drawer from "../../../drawer/Drawer";
import CategoryManage from "./CategoryManage";

const CategoryMangeDrawer = ({
  open,
  close = () => {},
  getResponse = () => {},
  data = {},
  type = "post-category",
  title = "Blog",
}) => {
  return (
    <>
      <Drawer
        open={open}
        onClose={(val) => {
          close(val);
        }}
        actualSize={"xl"}
        size={"xl3"}
        title={data?._id ? `Update ${title} Category` : `Add ${title} Category`}
        subtitle=""
        drawerBodyclassName="p-0 max-h-[calc(100%-90px)]"
      >
        <div className="h-full overflow-y-auto">
          <CategoryManage
            getResponse={getResponse}
            close={close}
            data={data}
            type={type}
          />
        </div>
      </Drawer>
    </>
  );
};

export default CategoryMangeDrawer;
